/* eslint-disable react-hooks/exhaustive-deps */
import { ALIGN, DataContentContent } from "src/modules/pe-landing-module/data/interfaces"
import { IPrimitiveProps } from "../section/Primitive"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import { Fragment, useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention } from "src/libs/utilities"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import { HTML as _HTML } from "../contentType"  
import { setHorizontalAlignToCSSRule, setVerticalAlignToCSSRule } from "../section/Section"

/* Protopia Ecosystem component */ 
const DataContentPrimitive = (props: IPrimitiveProps): JSX.Element => { 
    const primitive: DataContentContent = ( props.primitive || {} ) as DataContentContent
    const {position} = usePosition( primitive )
    const { data } = primitive
    useEffect(() => {
        addCSSClass(
            `landing-data-content-${ primitive.id }`,
            ` .landing-data-content-${ primitive.id } {
                ---position: absolute;
                width:${ getCssDemention(position.width, "100%") };
                height:${ getCssDemention(position.height, "200px") };
                ${ position.opacity ? `opacity:${ position.opacity };` : ``} 
                ${ setHorizontalAlignToCSSRule(primitive.horizontal_align || ALIGN.START)}; 
                ${ setVerticalAlignToCSSRule(primitive.vertical_align || ALIGN.START)}; 
            }`
        )
        return () => removeCSSClass(`landing-data-content-${ primitive.id }`)
    },[ position ])

    const getDataContent = () => { 
        return Array.isArray( data ) &&           
            data.map((d, i) => { 
                if(!d || d.isHidden) {
                    return <Fragment key={d.id + i.toString()}></Fragment>
                }
                const type = d.type 
                const DataComponent = type && components()[ type ]
                    ?
                    components()[ type ].c
                    :
                    _HTML 
 
                return <DataComponent
                    key={d.id + i.toString()}
                    section={ { composition: {}, id: d.id || (Math.random() + "").replace(".", "") } } 
                    data={ {...d, type: d.type } } 
                /> 
            })         
        
    } 
    
    return <div 
        className={`pe-primitive-container landing-data-content-primitive landing-data-content-${ primitive.id } ${primitive.className || ""}`}
        style={ primitive.style }
        data-primitive-type={primitive["data-primitive-type"]}
    > 
        <div 
            style={{ 
                // transform: `transform: scale(${ position.scale || 1 }) rotate(${ position.rotate || 0 }deg)`, 
                width: getCssDemention( position.width, "100%" ), 
                height: getCssDemention( position.height, "200px" ) 
            }}
        >
            { getDataContent() }
        </div>
    </div>  
}
export default DataContentPrimitive